(() => {
  const BUTTON_SELECTOR = '[data-collection-load-more]';
  const PAGINATION_SELECTOR = '[data-collection-pagination]';
  const GRID_SELECTOR = '#product-grid';
  const PRODUCT_SELECTOR = '[data-collection-product]';

  const setBusy = (button, busy) => {
    if (!button) return;
    button.disabled = busy;
    button.toggleAttribute('aria-busy', busy);
    button.textContent = busy ? 'Loading...' : 'Load more';
  };

  const sectionUrl = (rawUrl, sectionId) => {
    const url = new URL(rawUrl, window.location.origin);
    if (sectionId) url.searchParams.set('section_id', sectionId);
    return url.toString();
  };

  const updateTerminalCount = (container) => {
    if (!container || container.querySelector(PAGINATION_SELECTOR)) return;
    const grid = container.querySelector(GRID_SELECTOR);
    if (!grid) return;
    const count = grid.querySelectorAll(PRODUCT_SELECTOR).length;
    document.querySelectorAll('[data-collection-context-count]').forEach((node) => {
      node.dataset.collectionCount = String(count);
      const spans = node.querySelectorAll('span');
      if (spans[0]) spans[0].textContent = String(count);
      if (spans[1]) spans[1].textContent = count === 1 ? ' product' : ' products';
    });
    const desktopCount = document.getElementById('ProductCountDesktop');
    if (desktopCount) desktopCount.textContent = `${count} ${count === 1 ? 'product' : 'products'}`;
  };

  const loadNext = async (container, { auto = false } = {}) => {
    const pagination = container?.querySelector(PAGINATION_SELECTOR);
    const button = pagination?.querySelector(BUTTON_SELECTOR);
    const grid = container?.querySelector(GRID_SELECTOR);
    const nextUrl = pagination?.dataset.nextUrl || button?.dataset.nextUrl;
    const sectionId = container?.dataset.id || container?.closest('.shopify-section')?.id?.replace('shopify-section-', '');
    if (!pagination || !grid || !nextUrl || pagination.dataset.loading === 'true') return false;

    pagination.dataset.loading = 'true';
    if (!auto) setBusy(button, true);
    try {
      const response = await fetch(sectionUrl(nextUrl, sectionId), {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextGrid = doc.querySelector(GRID_SELECTOR);
      const nextPagination = doc.querySelector(PAGINATION_SELECTOR);
      if (!nextGrid) throw new Error('Next grid missing');

      const fragment = document.createDocumentFragment();
      const added = Array.from(nextGrid.children);
      added.forEach((item) => fragment.appendChild(item));
      grid.appendChild(fragment);

      const followingUrl = nextPagination?.dataset.nextUrl;
      if (followingUrl) {
        pagination.dataset.nextUrl = followingUrl;
        if (button) button.dataset.nextUrl = followingUrl;
        if (!auto) setBusy(button, false);
      } else {
        pagination.remove();
      }

      document.dispatchEvent(new CustomEvent('brilinton:collection-products-added', { detail: { container, grid, items: added } }));
      document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { sectionId }, bubbles: true }));
      updateTerminalCount(container);
      return true;
    } catch (error) {
      console.error('[Brilinton Load More]', error);
      if (!auto) setBusy(button, false);
      return false;
    } finally {
      if (pagination?.isConnected) pagination.dataset.loading = 'false';
    }
  };

  const autoFillSizeCollection = async (container) => {
    if (!container?.dataset.collectionSizeContext) return;
    const target = Number(container.dataset.count || 16);
    let grid = container.querySelector(GRID_SELECTOR);
    if (!grid) return;

    // Size collections are canonical Shopify collections. Load their remaining
    // source pages to terminal so the compact-bar count reflects the products
    // actually rendered on the Online Store, not Shopify's broader admin count.
    let guard = 0;
    while (container.querySelector(PAGINATION_SELECTOR) && guard < 10) {
      guard += 1;
      const loaded = await loadNext(container, { auto: true });
      if (!loaded) break;
      grid = container.querySelector(GRID_SELECTOR);
    }
    updateTerminalCount(container);
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest?.(BUTTON_SELECTOR);
    if (!button) return;
    event.preventDefault();
    const container = button.closest('#ProductGridContainer') || document.getElementById('ProductGridContainer');
    await loadNext(container, { auto: false });
  });

  const boot = () => {
    document.querySelectorAll('#ProductGridContainer[data-collection-size-context]:not([data-collection-size-context=""])')
      .forEach((container) => autoFillSizeCollection(container));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
